<div class="nic-card" [class.compact]="compact">
  <div class="nic-thumbnail"
       [class.clickable]="newsItem.contentSrc || newsItem.contentDocumentId"
       (click)="openContent()">
    @if (thumbnailUrl) {
      <img [src]="thumbnailUrl" [alt]="newsItem.title" class="nic-image" />
    } @else {
      <div class="nic-placeholder">
        <mat-icon>article</mat-icon>
      </div>
    }
  </div>
  <div class="nic-body">
    @if (!hideMetadata) {
      <h4 class="nic-title">{{ newsItem.title }}</h4>
    }
    @if (newsItem.description && !hideMetadata) {
      <p class="nic-description">{{ newsItem.description }}</p>
    }
    @if (!compact && newsItem.links?.length) {
      <div class="nic-links">
        <ul>
          @for (link of newsItem.links; track link) {
            <a [href]="link.url" target="_blank" class="nic-link">{{ link.text }}</a>
          }
        </ul>
      </div>
    }
    @if (newsItem.contentSrc || newsItem.contentDocumentId) {
      <a (click)="openContent()" class="nic-read-more">{{ compact ? 'View' : 'Read More' }}</a>
    }
    @if (!compact && !hideMetadata) {
      <span class="nic-date">Posted On: {{ newsItem.datePosted | date: 'M/dd/yyyy' }}</span>
    }
  </div>
</div>
